<template>
  <div>
    <van-dialog
      v-model="showRegister"
      class="register"
      :showConfirmButton="false"
    >
      <div class="title">
        <span v-if="title">{{ title }}</span>
        <van-icon class="icon" name="cross" @click="close" />
      </div>
      <van-field v-model="mobile" type="tel" label="手机号" placeholder="">
        <template #button>
          <van-button
            size="small"
            @click="sendCode"
            :disabled="disabled"
            type="default"
            >{{ text }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="smsRegCode"
        center
        clearable
        label="验证码"
        placeholder=""
      >
      </van-field>
      <van-button
        class="button"
        :loading="onSubmitLoading"
        loading-text="提交中..."
        :text="btnText"
        @click="onSubmit"
      />
      <p>
        登录表示同意
        <router-link class="validateStatusNane" to="/agreement/useService"
          >《用户使用服务协议》</router-link
        >
      </p>
    </van-dialog>
    <van-dialog
      v-model="authDialog"
      title="提示"
      message="您的微信授权已超时，需重新授权"
      confirmButtonText="去授权"
      @confirm="handleAuthDialogConfirm"
    />
  </div>
</template>

<script>
import AuthModel from '@/models/auth'
import { mapState, mapActions } from 'vuex'
import {
  saveOpenid,
  getJoinTraderId,
  getUserId,
  getRegisterSource
} from '@/utils/cookie'
import UserModel from '@/models/user'
import { HandleValidTime } from '@/utils/tools'
import { IsPhoneAvailable } from '@/utils/filters'
export default {
  props: {
    //弹框是否显示
    authShow: {
      type: Boolean,
      default: true
    },
    //注册按钮文案
    btnText: {
      type: String,
      default: '注册/登录'
    },
    //弹框标题
    title: {
      type: String,
      default: '验证码登录'
    }
  },
  data() {
    return {
      // (这里authDialog使用组件弹框不用函数调用dialog，是因为防止页面也有函数调用dialog，产生组件替换)
      authDialog: false, //去授权的弹框
      disabled: false, //是否禁用发送验证码按钮
      showRegister: this.authShow,
      mobile: '',
      text: '获取验证码',
      onSubmitLoading: false,
      smsRegCode: '',
      registerInfo: '', //储存手机号码，验证码，推荐人Id等信息,字符串形式
      annualNum: ''
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      token: state => state.user.token
    })
  },
  watch: {
    authShow() {
      this.showRegister = this.authShow
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async sendCode() {
      const mobile = this.mobile
      if (!IsPhoneAvailable(mobile)) {
        this.$notify('请输入正确的手机号')
      } else {
        this.disabled = true
        const res = await AuthModel.sendSMSCode(mobile)
        if (res.status === 200) {
          let wait = 60
          const time = setInterval(() => {
            if (wait === 1) {
              clearInterval(time)
              this.text = '发送验证码'
              this.disabled = false
            } else {
              wait--
              this.text = `${wait}`
            }
          }, 1000)
          this.$notify({
            message: '发送成功',
            duration: 1000,
            background: '#F8FEEE',
            color: '#262626',
            className: 'alert-success'
          })
        } else {
          this.disabled = false
          this.$notify(res.message)
        }
      }
    },
    //处理code超时，弹出‘需重新授权’弹框，点击弹框确认按钮
    handleAuthDialogConfirm() {
      if (this.registerInfo !== '') {
        sessionStorage.setItem('registerInfo', this.registerInfo)
        this.$parent.handleWxAuthority() //mixin文件的方法
      }
    },
    async onSubmit() {
      this.onSubmitLoading = true
      let mobile = this.mobile
      let shareUserId = getUserId()
      let joinTraderId = getJoinTraderId()
      let registerSource = getRegisterSource()
      if (!IsPhoneAvailable(mobile)) {
        this.$notify('请输入正确的手机号')
        this.onSubmitLoading = false
        return
      }
      const smsRegCode = this.smsRegCode.trim()
      if (smsRegCode.length < 4) {
        this.$notify('请输入正确验证码')
        this.onSubmitLoading = false
        return
      }

      let that = this
      let Timeoutt = setTimeout(() => {
        that.onSubmitLoading = false
      }, 10000)

      let res = null
      let redirectUrl = this.$route.query.redirectUrl
      if (redirectUrl.indexOf('annualNum') != -1) {
        this.annualNum = redirectUrl.split('annualNum=')[1].slice(0, 4)
      }
      let data = {
        mobile,
        smsRegCode,
        joinTraderId,
        shareUserId,
        registerSource,
        annualNum: this.annualNum
      }
      let time1 = JSON.parse(sessionStorage.getItem('codeTimeStamp'))
      let time2 = new Date().getTime()
      //如果不在18分钟内就return
      if (this.utils.isWeiXin() && !HandleValidTime(time1, time2)) {
        let registerInfo = {
          mobile,
          smsRegCode,
          joinTraderId,
          shareUserId,
          registerSource
        }
        registerInfo = JSON.stringify(registerInfo)
        this.registerInfo = registerInfo
        this.authDialog = true
        return
      }
      // 获取token
      if (this.$route.query.code) {
        const code = this.$route.query.code
        data.code = code
        res = await AuthModel.register(data) //有code用这接口
      } else {
        data.src = 'oa'
        res = await AuthModel.loginByCode(data) //没有code用这接口
      }

      // 清除定时器Timeoutt
      clearTimeout(Timeoutt)
      if (res.status === 200) {
        // 获取token成功后，判断是否是带有code请求，
        //    >>> 是，则将获取的token写入Vuex，将openId写入cookies
        //    >>> 不是，则将写在data的token写入Vuex
        if (this.$route.query.code) {
          this.setToken(res.data.token)
          saveOpenid(res.data.openId)
        } else {
          this.setToken(res.data)
        }

        // 获取用户信息，是则将用户信息写入Vuex
        const UserInfo = await UserModel.getUserInfo()
        if (UserInfo.status === 200) {
          this.setUserInfo(UserInfo.data)
        }
        //注册成功回调，并刷新当前页面
        that.$emit('confirmFunc')
        location.reload()
      } else {
        // eslint-disable-next-line
        const fundebug = require('fundebug-javascript')
        if ('fundebug' in window) {
          if (this.$route.query.code) {
            fundebug.test('register', data)
          } else {
            fundebug.test('loginByCode', data)
          }
        }
        let message = res.message ? res.message : '系统繁忙请稍后再试'
        this.$dialog
          .alert({
            title: '提示',
            message: message
          })
          .then(() => {})
      }
      this.onSubmitLoading = false
    },
    ...mapActions(['setUserInfo', 'setToken'])
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/global.less';
.register {
  .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20 / @r 32 / @r;
    height: 40 / @r;
    span {
      font-size: 30 / @r;
      color: #333;
      font-weight: bold;
    }
    .icon {
      position: absolute;
      right: 32 / @r;
      top: 50%;
      margin-top: -16 / @r;
      opacity: 0.19;
    }
  }
  p {
    text-align: center;
    font-size: 24 / @r;
    color: #999;
    margin-top: -20 / @r;
    margin-bottom: 40 / @r;
    .validateStatusNane {
      color: #999;
      text-decoration: underline;
    }
  }
}
.button {
  background: #ff4040;
  width: calc(100% - 50px);
  height: 98 / @r;
  border-radius: 98 / @r;
  margin: 25px;
  color: #fff;
  text-align: center;
  font-size: 30 / @r;
  line-height: 98 / @r;
}
/deep/ .van-cell {
  color: #999999;
}
</style>
